import React, { ComponentProps } from "react";
import { Button } from "@clarkinc/zest-design-system/ui";
import Stars from "~/common/Stars";
import { cls } from "@wss/cls";

type ReviewsLinkProps = Partial<ComponentProps<typeof Button>> & {
  numberOfReviews: number;
  rating: number;
  minimalPageVersion?: boolean;
  itemNumber: string;
};

const ReviewsLink = ({
  numberOfReviews,
  rating,
  minimalPageVersion,
  itemNumber,
  className,
  ...rest
}: ReviewsLinkProps) => {
  let reviewText = "Leave a review";
  if (numberOfReviews) {
    reviewText = `${numberOfReviews} review`;
    if (numberOfReviews > 1) reviewText += "s";
  }

  const handleReviewsLinkClick = () => {
    if (minimalPageVersion) {
      window.location.href = `/product-reviews/${itemNumber}.html`;
      return;
    }
    const elementToJumpTo = numberOfReviews
      ? document?.getElementById("reviews")
      : document?.getElementById("writeAReview");

    elementToJumpTo?.focus();
    elementToJumpTo?.scrollIntoView();
  };

  return (
    <Button
      theme="wss"
      variant="plain"
      color="green"
      size="medium"
      {...rest}
      className={cls(
        "text-xs items-center gap-1 mr-2 focus:outline-green-500",
        className,
      )}
      onClick={handleReviewsLinkClick}
    >
      <Stars rating={rating} />
      <span>
        {numberOfReviews ? (
          <span className="hidden xxxs:inline">Read </span>
        ) : null}
        {reviewText}
      </span>
    </Button>
  );
};

export default ReviewsLink;
